import InfoIcon from '@material-ui/icons/Info';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';

class Notification extends React.Component {

    render() {

        const { text, error, dataTest, spaceRight } = this.props;
        const color = error ? '#ffffff' : '#CA4F0C';
        const bColor = error ? '#DD2C00' : '#ffffff';

        return (
            <div data-test={dataTest || "notification"}
                style={{
                    backgroundColor: bColor,
                    border: 'solid 1px ' + color,
                    borderRadius: '4px',
                    padding: '6px 6px 4px 6px',
                    marginBottom: 4,
                    ...(spaceRight) && { marginRight: '30px' }
                }}>
                <Typography variant="body2" style={{
                    color: color,
                    textIndent: '-2.3em',
                    marginLeft: '2.2em'
                }}>
                    <InfoIcon style={{ verticalAlign: 'middle', transform: 'translateY(-1px)' }} />
                    <span style={{ marginLeft: 6, wordBreak: 'break-word' }}>
                        {text}
                    </span>
                </Typography>
            </div >

        );
    }
}

Notification.defaultProps = {
    error: false,
    spaceRigth: false
};

Notification.propTypes = {
    text: PropTypes.string.isRequired,
    error: PropTypes.bool,
    spaceRight: PropTypes.bool,
    dataTest: PropTypes.string
};

export default Notification;